
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import StaffTabs from "./StaffTabs";
import usePrivateLink from "../config/usePrivateLink";

export default function StaffLayout({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const visibleTabs = StaffTabs.filter((tab) =>
    hasAccess(tab.path)
  );

  return (
    <>
      <ModuleHeader tabs={visibleTabs} />
      {children}
    </>
  );
}
